import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboUbicacion`, method: 'GET', body: null, token: token})
}
